import InputMask from 'react-input-mask';
import styled, { css } from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import spacing from '../../../helpers/spacing';
import { underlineOnFocus, underlineOnValue } from '../InputUnderline';

export const Container = styled.div`
  display: flex;
  position: relative;

  ${({ prefix }) =>
    prefix &&
    css`
    &::before {
      content: '${prefix}';
      position: absolute;
      left: ${spacing(2)};
      top: 50%;
      ${fonts.paragraph};
      transform: translateY(-50%);
      z-index: 1;
    }
  `}
`;

const inputStyling = css<{ prefix?: string }>`
  width: 100%;
  height: ${spacing(7)};

  padding: 0 ${spacing(2)};

  ${({ prefix }) =>
    prefix &&
    css`
      padding-left: ${spacing(3)};
    `}

  ${fonts.paragraph};

  border: 1px solid ${colors.neutral03};
  border-radius: ${({ theme }) => theme.inputRadius};

  ::-ms-clear {
    display: none;
  }

  &:focus-visible {
    outline: none;
  }

  ${underlineOnFocus}
  ${underlineOnValue}
`;

export const StyledInput = styled.input`
  ${inputStyling}
`;

export const StyledInputMask = styled(InputMask)`
  ${inputStyling}
`;
